module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audit_edit_pf pl10 mt20"
  }, [(_vm.control.schedule) ? _c('div', {
    staticClass: "mt20 mb20"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("审核进展：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.control.schedule))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [(_vm.control.content) ? _c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n                (" + _vm._s(_vm.control.content) + ")")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("税务信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.control.view == 0),
      expression: "control.view == 0"
    }],
    staticClass: "mt20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "纳税人识别号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.financeData.taxpayerRegistrationCode))]), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldFinanceData.taxpayerRegistrationCode) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.oldFinanceData.taxpayerRegistrationCode))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "纳税人类型："
    }
  }, [(_vm.financeData.taxpayerType == 1) ? _c('span', [_vm._v("一般纳税人")]) : _vm._e(), _vm._v(" "), (_vm.financeData.taxpayerType == 2) ? _c('span', [_vm._v("小规模纳税人")]) : _vm._e(), _vm._v(" "), (_vm.oldFinanceData.taxpayerType == 1 && _vm.control.compare == 1) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   一般纳税人")]) : _vm._e(), _vm._v(" "), (_vm.oldFinanceData.taxpayerType == 2 && _vm.control.compare == 1) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   小规模纳税人")]) : _vm._e()]), _vm._v(" "), (_vm.financeData.taxpayerType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "一般纳税人资格认定表："
    }
  }, [_c('div', [(_vm.financeData.generalTaxpayerFile) ? [_vm._l((_vm.financeData.generalTaxpayerFile.split(',')), function(gtFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": gtFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }), _vm._v(" "), (_vm.oldFinanceData.generalTaxpayerFile) ? _vm._l((_vm.oldFinanceData.generalTaxpayerFile.split(',')), function(sgtFile) {
    return (_vm.control.compare == 1) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": sgtFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }) : _vm._e()] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("货款支付账户")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin": "0 auto",
      "margin-bottom": "22px",
      "margin-top": "22px"
    },
    attrs: {
      "data": _vm.financeData.accounts,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "银行开户名",
      "min-width": "200",
      "align": "center",
      "prop": "accountName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountNumber",
      "label": "银行帐号",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bankName",
      "label": "银行名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.financeData.registeredCountry != 1) ? _c('el-table-column', {
    attrs: {
      "prop": "swiftCode",
      "label": "SwiftCode",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.control.compare == 1 && _vm.financeData.accounts.length != _vm.oldFinanceData.accounts.length) ? _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin": "0 auto",
      "margin-bottom": "22px",
      "margin-top": "22px",
      "border": "2px solid #ff4a7d"
    },
    attrs: {
      "data": _vm.oldFinanceData.accounts,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "银行开户名",
      "min-width": "200",
      "align": "center",
      "prop": "accountName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountNumber",
      "label": "银行帐号",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bankName",
      "label": "银行名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.financeData.registeredCountry != 1) ? _c('el-table-column', {
    attrs: {
      "prop": "swiftCode",
      "label": "SwiftCode",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt50 mb50",
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnPage
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.control.audit == 1) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.auditRecord(0)
      }
    }
  }, [_vm._v("审核通过")]) : _vm._e(), _vm._v(" "), (_vm.control.audit == 1) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.auditRecord(1)
      }
    }
  }, [_vm._v("审核驳回")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.control.view == 1),
      expression: "control.view == 1"
    }],
    staticClass: "mt20"
  }, [_c('el-form', {
    ref: "financeData",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.financeData,
      "rules": _vm.rules,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "纳税人识别号：",
      "prop": "taxpayerRegistrationCode"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入纳税人识别号"
    },
    model: {
      value: (_vm.financeData.taxpayerRegistrationCode),
      callback: function($$v) {
        _vm.$set(_vm.financeData, "taxpayerRegistrationCode", $$v)
      },
      expression: "financeData.taxpayerRegistrationCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "纳税人类型：",
      "prop": "taxpayerType"
    }
  }, [_c('el-radio-group', {
    staticClass: "ml_10",
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.financeData.taxpayerType),
      callback: function($$v) {
        _vm.$set(_vm.financeData, "taxpayerType", $$v)
      },
      expression: "financeData.taxpayerType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("一般纳税人")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("小规模纳税人")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.financeData.taxpayerType == 1),
      expression: "financeData.taxpayerType == 1"
    }],
    staticClass: "mt20",
    attrs: {
      "label": "一般纳税人资格认定表："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star178"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "file-list": _vm.financeData.file,
      "list-type": "picture-card",
      "name": "pic",
      "before-upload": _vm.beforeUpload,
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleUpload,
      "on-remove": _vm.handleRemoveGeneralTaxpayerFile
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_1),
      expression: "pic_1"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("货款支付账户")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-button', {
    staticClass: "vtb",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bankFormVisible = true
      }
    }
  }, [_vm._v("添加账户")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin": "0 auto",
      "margin-bottom": "22px",
      "margin-top": "22px"
    },
    attrs: {
      "data": _vm.financeData.accounts,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "银行开户名",
      "min-width": "200",
      "align": "center",
      "prop": "accountName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountNumber",
      "label": "银行帐号",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bankName",
      "label": "银行名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.financeData.registeredCountry != 1) ? _c('el-table-column', {
    attrs: {
      "prop": "swiftCode",
      "label": "SwiftCode",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "disabled": scope.row.id > 0,
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.removeDomain(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt50 mb50",
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnPage
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm(0)
      }
    }
  }, [_vm._v("暂存")]), _vm._v(" "), _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.control.status == 4 ? '重新提交' : '提交'))])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "货款支付账户",
      "visible": _vm.bankFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.bankFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "account",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.account,
      "rules": _vm.bankRules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "银行开户名：",
      "prop": "accountName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写银行开户名",
      "maxlength": 50
    },
    model: {
      value: (_vm.account.accountName),
      callback: function($$v) {
        _vm.$set(_vm.account, "accountName", $$v)
      },
      expression: "account.accountName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "银行帐号：",
      "prop": "accountNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写银行帐号",
      "maxlength": 30
    },
    model: {
      value: (_vm.account.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.account, "accountNumber", $$v)
      },
      expression: "account.accountNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "银行名称：",
      "prop": "bankName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写银行名称",
      "maxlength": 50
    },
    model: {
      value: (_vm.account.bankName),
      callback: function($$v) {
        _vm.$set(_vm.account, "bankName", $$v)
      },
      expression: "account.bankName"
    }
  })], 1), _vm._v(" "), (_vm.financeData.registeredCountry != 1) ? _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "SwiftCode："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写SwiftCode",
      "maxlength": 35
    },
    model: {
      value: (_vm.account.swiftCode),
      callback: function($$v) {
        _vm.$set(_vm.account, "swiftCode", $$v)
      },
      expression: "account.swiftCode"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "main_word rule_star100"
  }, [_vm._v("*")])], 1) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "省：",
      "prop": "province"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写省",
      "maxlength": 30
    },
    model: {
      value: (_vm.account.province),
      callback: function($$v) {
        _vm.$set(_vm.account, "province", $$v)
      },
      expression: "account.province"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "市：",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写市",
      "maxlength": 50
    },
    model: {
      value: (_vm.account.city),
      callback: function($$v) {
        _vm.$set(_vm.account, "city", $$v)
      },
      expression: "account.city"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.bankFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a2405f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierInfo/manage/financeInfo.vue
// module id = 532
// module chunks = 0